import React, { Component } from 'react';
import { Loader } from 'react-loaders';
import { translate } from 'react-i18next';

import Map from 'components/Map/Map';
import Menu from 'components/Menu/Menu';
import Header from 'components/Header/Header';
import CustomModal from 'components/CustomModal/CustomModal';
import Utils from 'utils/Utils';
import {
  initMap, isLoadedMap, mapjs, highlightFeatures, addCustomWMSLayer, addFlightLayers,
	newGeoJSONLayer, removeAllCustomWMSLayer, isCustomWMSLayerActive, removeAllFlightLayers,
} from 'utils/Visor';

import 'loaders.css/loaders.min.css';
import './Layout.css';

declare var CONFIGURATIONS;

class Layout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      menuOpened: true,
      blocking: true,
      loading: true,
      selectedFeatures: [],
      selectedFullFeatures: [],
      flights: [],
      selectedFlight: {},
      allFlights: [],
    };
  }

  componentDidMount() {
    const _this = this;
    _this.setState({ loading: false }, () => {
      initMap(_this.getSelectedFlight, _this.getSelectedFeatures, _this.getSelectedFullFeatures, _this.selectFeatures, _this.unblock, _this.props.t);
      if (_this.state.menuOpened === true) {
        setTimeout(() => {
          document.querySelector('#div-contenedor.m-mousesrs-container').classList.add('mousesrs-correct-position');
          document.querySelector('#div-contenedor > div.m-mouse-srs').innerHTML = `708.661,10&nbsp;&nbsp;&nbsp;4.588.966,37 | <b role="button" tabindex="null" aria-label="Clic o Enter para modificar el EPSG" class="m-mousesrs-pointer">EPSG:25830</b>`;
        }, 200);
      }
    });
  }

  block = () => {
    this.setState({ blocking: true });
  }

  unblock = () => {
    this.setState({ blocking: false });
  }

  updateFlights = (flights) => {
    this.setState({ flights });
  }

  setAllFlights = (flights) => {
    this.setState({ allFlights: flights });
  }

  getSelectedFlight = () => {
    return this.state.selectedFlight;
  }

  getSelectedFeatures = () => {
    return this.state.selectedFeatures;
  }

  getSelectedFullFeatures = () => {
    return this.state.selectedFullFeatures;
  }

  selectFlight = (flight) => {
    this.setState({ selectedFlight: flight });
  }

  allFotogramsOpenedSameLayer = () => {
    const _this = this;
    let res = false;
    if (this.state.selectedFeatures.length > 0) {
      let opened = this.state.selectedFullFeatures.filter((f) => {
        const flight = _this.state.flights.filter((flight) => {
          return f.properties.fly_id.indexOf(flight.fly_id) > -1;
        })[0];

        if (flight !== undefined) {
          return isCustomWMSLayerActive(f.properties.layer_id) && _this.state.selectedFlight.fly_id === flight.fly_id;
        } else {
          return false;
        }
      });

      res = res || opened.length > 0;
    } else {
      res = res || true;
    }

    return res;
  }

  selectFeatures = (selectedFeatures, selectedFullFeatures, fromMap) => {
    const _this = this;
    const oldSelected = _this.state.selectedFeatures;
    if (fromMap === true) {
      highlightFeatures(selectedFeatures);
      selectedFeatures.forEach((f) => {
        if (oldSelected.indexOf(f) === -1) {
          _this.block();
          if (!_this.allFotogramsOpenedSameLayer()) {
            removeAllCustomWMSLayer();
          }

					const fullFeature = selectedFullFeatures.filter(item => item.properties[CONFIGURATIONS.fotogram_attr] === f)[0];
          addCustomWMSLayer(fullFeature.properties.url_wms, fullFeature.properties.layer_id, this.unblock);
        }
      });

      this.setState({ selectedFeatures: selectedFeatures, selectedFullFeatures: selectedFullFeatures }, () => {
        if (!_this.state.menuOpened) {
          _this.openMenuHandler();
        }
      });
    } else {
      highlightFeatures(selectedFeatures);
      this.setState({ selectedFeatures: selectedFeatures, selectedFullFeatures: selectedFullFeatures });
    }
  }

  addCentersLayer = (centersLayer) => {
    this.setState({ centersLayer: centersLayer });
  }

  addMarksLayer = (marksLayer) => {
    this.setState({ marksLayer: marksLayer });
  }

  selectTempFlight = (flightSelected) => {
    const _this = this;
    if (flightSelected !== undefined && this.state.selectedFlight.fly_id !== flightSelected.fly_id) {
      removeAllFlightLayers();
      this.block();
			const coverageFile = flightSelected.resources.filter((r) => r.mimetype === 'application/geo+json' && r.name.indexOf('Huella Vuelo') > -1)[0].url;
			const centersFile = flightSelected.resources.filter((r) => r.mimetype === 'application/geo+json' && r.name.indexOf('Centroide Fotogramas') > -1)[0].url;
			const marksFile = flightSelected.resources.filter((r) => r.mimetype === 'application/geo+json' && r.name.indexOf('Huella Fotogramas') > -1)[0].url;
      Promise.all([Utils.getFile(coverageFile), Utils.getFile(centersFile), Utils.getFile(marksFile)]).then((geojsons) => {
        const coverage = newGeoJSONLayer({ source: geojsons[0], name: CONFIGURATIONS.coverage_name + ' ' + flightSelected.name, extract: false }, { displayInLayerSwitcher: false });
        const centers = newGeoJSONLayer({ source: geojsons[1], name: CONFIGURATIONS.centers_name, extract: false }, { displayInLayerSwitcher: false });
        const marks = newGeoJSONLayer({ source: geojsons[2], name: CONFIGURATIONS.marks_name, extract: false }, { displayInLayerSwitcher: false });
        _this.selectFlight(flightSelected);
        addFlightLayers(coverage, centers, marks, _this.getSelectedFeatures, _this.unblock);
        _this.addCentersLayer(centers);
        _this.addMarksLayer(marks);
      }).catch((err) => {
        _this.unblock();
      });
    } else if (flightSelected === undefined) {
      removeAllFlightLayers();
      _this.selectFlight({});
    }
  }

  openMenuHandler = (evt) => {
    const { menuOpened } = this.state;
    this.setState({ menuOpened: !menuOpened });
    if (isLoadedMap()) {
      setTimeout(() => {
        const center = mapjs.getCenter();
        mapjs.getMapImpl().updateSize();
        if (this.state.menuOpened === true) {
          document.querySelector('#div-contenedor.m-mousesrs-container').classList.add('mousesrs-correct-position');
        } else {
          document.querySelector('#div-contenedor.m-mousesrs-container').classList.remove('mousesrs-correct-position');
        }

        setTimeout(() => {
          mapjs.setCenter(center);
          mapjs.refresh();
        }, CONFIGURATIONS.map_loaded_timeout);
      }, CONFIGURATIONS.map_loaded_timeout);
    }
  };

  render() {
    const { menuOpened, selectedFeatures, selectedFullFeatures, centersLayer, flightLayer, flightName, flights, allFlights } = this.state;

    return (
      <div className='content-wrapper'>
        <Header />
        <section className='layout-wrapper'>
          <Menu openMenuHandler={this.openMenuHandler} menuOpened={menuOpened} block={this.block} unblock={this.unblock} flights={flights}
            getSelectedFlight={this.getSelectedFlight} getSelectedFeatures={this.getSelectedFeatures} selectFeatures={this.selectFeatures}
            selectTempFlight={this.selectTempFlight} addMarksLayer={this.addMarksLayer} addCentersLayer={this.addCentersLayer}
            allFotogramsOpenedSameLayer={this.allFotogramsOpenedSameLayer} selectFlight={this.selectFlight} updateFlights={this.updateFlights}
            selectedFeatures={selectedFeatures} centersLayer={centersLayer} flightLayer={flightLayer} flightName={flightName}
            selectedFullFeatures={selectedFullFeatures} setAllFlights={this.setAllFlights} allFlights={allFlights} />
          <Map />
        </section>
        <CustomModal open={this.state.blocking} blocking={true} onClose={this.unblock}>
          <div className='block-loader-container'>
            <Loader active type={'ball-triangle-path'} color='#006699' />
          </div>
        </CustomModal>
      </div>
    );
  }
}

export default translate()(Layout);
